import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';
import get from 'lodash/get';
import {
  formatSnapshotLicenseUsage,
  toSnapshotLicenseUsageValues,
} from 'pages/SnapshotManagement/LicenseUsage/licenseUsageFormatter';
import { getSnapshotSize } from 'pages/SnapshotManagement/getSnapshotSize';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';
import type { ISnapshot } from './SnapshotTypes';

type Props = {
  msg: AppTranslations['snapshotManagement'];
  snapshot: ISnapshot;
};

export const SnapshotInfoTooltip: FC<Props> = (props) => {
  const licenseUsage = props.snapshot.licenseUsage
    ? formatSnapshotLicenseUsage(
        toSnapshotLicenseUsageValues(props.snapshot.licenseUsage),
      )
    : null;

  return (
    <TooltipIcon
      className='text-icon-base'
      size='sm'
      icon='fa-circle-info'
      content={
        <>
          <span className='font-bold'>{props.msg.detail.version}</span>{' '}
          {props.snapshot.version}
          <br />
          {props.snapshot.initialVersion && (
            <>
              <span className='font-bold'>
                {props.msg.detail.createdOnVersion}
              </span>{' '}
              {props.snapshot.initialVersion}
              <br />
            </>
          )}
          {licenseUsage ? (
            <>
              <span className='font-bold'>{props.msg.detail.licenseUsage}</span>{' '}
              {licenseUsage}
            </>
          ) : (
            <>
              <span className='font-bold'>{props.msg.detail.devices}</span>{' '}
              {(props.snapshot.totalDevCount || 0).toLocaleString()}/
              {(props.snapshot.licensedDevCount || 0).toLocaleString()}
            </>
          )}
          <br />
          <span className='font-bold'>{props.msg.detail.loadedSize}</span>{' '}
          {getSnapshotSize(props.msg, props.snapshot.loadedSize)}
          <br />
          <span className='font-bold'>
            {get(props.msg, 'detail.unloadedSize')}
          </span>{' '}
          {getSnapshotSize(props.msg, props.snapshot.unloadedSize)}
          <br />
        </>
      }
      interactive={true}
      tooltipProps={{ highlighted: true }}
    />
  );
};
